import React, { useState } from 'react';
import cross from '../../assets/images/model/image-cross.svg';
import imagInfo from '../../assets/images/model/info.svg';
import minimize from '../../assets/images/model/minimize-2.svg';
import download from '../../assets/images/model/download.svg';
import externalLink from '../../assets/images/model/external-link.svg';
import plus from '../../assets/images/model/plus.svg';
import minus from '../../assets/images/model/minus.svg';
import rotate from '../../assets/images/model/rotate-cw.svg';

const ImageVideoViewer = ({ setMaximizeImage, imageVideoUrl }) => {
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const handleRotate = () => {
    setRotation((prevRotation) => prevRotation + 90);
  };

  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.1)); // minimum zoom level of 0.1
  };

  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.1, 3)); // maximum zoom level of 3
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = imageVideoUrl.url;
    link.download = 'media'; // or set a specific filename if you want
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className='parent-background'>
      {/* Sticky Top Header */}
      <div className='image-info'>
        <img src={imagInfo} alt='info' onClick={(e) => e.stopPropagation()} />

        <img
          src={cross}
          alt='close'
          onClick={(e) => {
            e.stopPropagation();
            setMaximizeImage(false);
          }}
        />
      </div>

      {/* Main Content */}
      <div className='media-content'>
        {imageVideoUrl.type === 'image' ? (
          <div
            className='image-preview'
            style={{
              // transform: `scale(${zoom}) `,
              transform: `scale(${zoom}) rotate(${rotation}deg)`,
              width: '100%',
              height: rotation % 180 === 0 ? '63.8%' : '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={imageVideoUrl?.url}
              alt='content'
              style={{
                // width: rotation % 180 === 0 ? "856px" : "720px",
                width: '100%',
                height: '100%',
                objectFit: 'contain', // Ensures the image scales to fit the container
              }}
            />
          </div>
        ) : imageVideoUrl.type === 'video' ? (
          <div className='video-preview'>
            <iframe
              width='100%'
              height='500px'
              src={imageVideoUrl?.url}
              title='YouTube video player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              referrerPolicy='strict-origin-when-cross-origin'
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          ''
        )}
      </div>

      {/* Sticky Bottom Footer */}
      <div className='image-info' style={{ bottom: 0 }}>
        <div className='left-side-icon'>
          <img src={rotate} alt='rotate' onClick={handleRotate} />
          <img src={minus} alt='zoom-out' onClick={handleZoomOut} />
          <div
            style={{
              width: '175px',
              height: '2px',
              backgroundColor: '#fff',
              borderRadius: '19px',
            }}
            className='progress-bar-for-zoominout'
          >
            <div
              style={{
                width: `${((zoom - 0.1) / 2.9) * 100}%`, // scale zoom level to progress width
                height: '100%',
                backgroundColor: '#FF6347', // for example, orange color
                borderRadius: '19px',
              }}
            ></div>
          </div>
          <img src={plus} alt='zoom-in' onClick={handleZoomIn} />
        </div>
        <div className='right-side-icon'>
          <img src={minimize} alt='minimize' onClick={() => setMaximizeImage(false)} />
          <img src={download} alt='download' onClick={handleDownload} />
          <img
            src={externalLink}
            alt='open in new tab'
            onClick={() => window.open(imageVideoUrl.url, '_blank')}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageVideoViewer;
